import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BrokerPortalFeatureCodes } from '@brokerportal/common/enums';
import { FeatureFlagService } from '@brokerportal/common/services';
import { ResetChatBoxRequiredCookieName } from 'app/constants';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'bp-exchange-auth',
    templateUrl: './exchange-auth.component.html',
    styleUrls: ['./exchange-auth.component.scss']
})
export class ExchangeAuthComponent implements OnInit {
    isLoading: boolean;
    constructor(
        private route: ActivatedRoute,
        private featureFlagService: FeatureFlagService,
        private cookieService: CookieService
    ) {}

    ngOnInit() {
        this.cookieService.set(ResetChatBoxRequiredCookieName, 'true', {
            expires: 1, // 1 day
            path: '/',
            sameSite: 'Lax'
        });

        this.isLoading = true;
        const fusionAuthConfig = environment.fusionAuth;
        const baseApplicationUrl = environment.baseAppUrl;

        const queryParams = this.route.snapshot.queryParams;
        const returnUrl = `${baseApplicationUrl}/${queryParams['returnUrl'] || 'dashboard'}`;

        window.location.replace(
            `${environment.membersUrl}/login/Auth?client_id=${fusionAuthConfig.clientId}&returnUrl=${returnUrl}`
        );
    }
}
